import React from "react";
import { useParams, Navigate } from "react-router-dom";

/**
 * The public provider page at /:bookingUrl renders the same design-system
 * link-in-bio the editor previews, so "preview" is simply the live page.
 */
const LinkInBioPreviewPage: React.FC = () => {
  const { bookingUrl } = useParams<{ bookingUrl: string }>();
  if (!bookingUrl) return <Navigate to="/linkinbio/dashboard" replace />;
  return <Navigate to={`/${bookingUrl}`} replace />;
};

export default LinkInBioPreviewPage;
